import { Link } from 'react-router-dom';
import Reveal from '../../../shared/Reveal/Reveal';
import { useVpsHostingContinuityContent } from '../../../../hooks/useVpsHostingContinuityContent';
import './Continuity.css';

const Continuity = () => {
  const { content, isLoading } = useVpsHostingContinuityContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, text, cta } = content;

  return (
    <section className="vps-hosting-continuity">
      <div className="vps-hosting-continuity__inner">
        <Reveal className="vps-hosting-continuity__content">
          <h2 className="vps-hosting-continuity__title">{title}</h2>
          {text ? <p className="vps-hosting-continuity__text">{text}</p> : null}
          {cta?.text && cta?.url ? (
            <Link
              to={cta.url}
              className="vps-hosting-continuity__cta luxury-btn"
            >
              {cta.text}
            </Link>
          ) : null}
        </Reveal>
      </div>
    </section>
  );
};

export default Continuity;
